import { defineStore } from 'pinia'
import { ref } from 'vue'

/**
 * Store for managing unregistered user data state
 * Minimal store for specific unregistered user functionality
 */
export const useUnregUserStore = defineStore('unregUser', () => {
  // Selected user state for API queries
  const selectedUser = ref('')

  // Search results cache (if needed outside of vue-query)
  const searchResults = ref<any>(null)
  const searchLoading = ref(false)

  // Actions
  function setSelectedUser(user: string) {
    // Convert any input to string for graceful handling
    selectedUser.value = String(user)
  }

  function setSearchResults(results: any) {
    searchResults.value = results
  }

  function setSearchLoading(loading: boolean) {
    searchLoading.value = loading
  }

  function clearSelectedUser() {
    selectedUser.value = ''
  }

  function reset() {
    selectedUser.value = ''
    searchResults.value = null
    searchLoading.value = false
  }

  return {
    // State
    selectedUser,
    searchResults,
    searchLoading,

    // Actions
    setSelectedUser,
    setSearchResults,
    setSearchLoading,
    clearSelectedUser,
    reset
  }
})
